// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3plfB","form":"styles_form__tHsvY"};